<template>
  <div
    class="app-page"
  >
    <PageHeader
      :title="pageTitle"
      :page-desc="pageDesc"
      :hide-breadcrumb="hideBreadcrumb"
      :breadcrumb-list="breadcrumbList"
    />
    <div class="page-main">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import PageHeader from '../../Layout/PageHeader/PageHeader'
import { createNamespacedHelpers } from 'vuex'
import { getBreadcrumbList } from '../../../utils/utils'
const { mapState } = createNamespacedHelpers('app')

export default {
  name: 'Page',
  components: {
    PageHeader
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    pageDesc: {
      type: String,
      default: ''
    },
    hideBreadcrumb: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      breadcrumbList: [],
      pageTitle: this.title
    }
  },
  created () {
    this.initPageHeader()
  },
  watch: {
    $route: {
      handler () {
        this.initBreadCrumb()
      }
    }
  },
  computed: {
    ...mapState([
      'menuList'
    ])
  },
  methods: {
    initPageHeader () {
      const list = getBreadcrumbList(this.$route.path, this.menuList)
      this.breadcrumbList = list
      this.pageTitle = this.pageTitle ? this.pageTitle : list[list.length - 1].meta.title
    }
  }
}
</script>

<style scoped lang="less" type="text/less">
.app-page {
  width: 100%;
  height: 100%;
  .page-main {
    height: auto;
    background: #ffffff;
    margin: 15px;
    padding: 15px;
  }
}
</style>
